const SECTION_NAMES = {
    'A' : "Stainless Steel Hose Kits: Two (2) 2' or 3' Braided Hoses with Automatic Flow Control, Shut-Off Valves and  PT Plugs",
    'B' : "Stainless Steel Hose Kits: Two (2) 2' or 3' Braided Hoses with Manual Balance, Shut-Off Valves w/ Memory Stop and PT Plugs",
    'C' : 'Stainless Steel Hoses ONLY - 36" Length (2 Required per Heat Pump)'
}

const FEET_OPTIONS = [
    {'feet' : '2', 'id' : '7602', 'sections' : ['A', 'B']},
    {'feet' : '3', 'id' : '7603', 'sections' : ['A', 'B', 'C']}
]

const OPTIONS = {

    'MCL006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCR006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCB006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCP006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCT006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCK006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCF006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRL006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRR006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRB006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRP006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRT006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRK006' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCL009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCR009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCB009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCP009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCT009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCK009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCF009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRL009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRR009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRB009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRP009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRT009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRK009' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},   
    'MCL012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCR012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCB012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCP012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCT012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCK012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCF012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRL012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRR012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRB012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRP012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRT012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRK012' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}}, 
    'MCL015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCR015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCB015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCP015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCT015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCK015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCF015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRL015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRR015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRB015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRP015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRT015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRK015' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}}, 
    'MCL018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCR018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCB018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCP018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCT018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCK018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MCF018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRL018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRR018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRB018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRP018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRT018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}},
    'MRK018' : {'connection' : '1/2"', 'options' : {'A':[
                {'id' : '135015', 'afr' : '1.5', 'pt' : '3.0'},
                {'id' : '135020', 'afr' : '2.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '130'}
            ], 'C':[
            ]}}, 
    'MCL024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCR024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCB024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCP024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCT024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCK024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCF024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRL024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRR024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRB024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRP024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRT024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRK024' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCL030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCR030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCB030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCP030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCT030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCK030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCF030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRL030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRR030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRB030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRP030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRT030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRK030' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCL036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCR036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCB036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCP036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCT036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCK036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCF036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRL036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRR036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRB036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRP036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRT036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRK036' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCL042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCR042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCB042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCP042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCT042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCK042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCF042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRL042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRR042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRB042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRP042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRT042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MRK042' : {'connection' : '3/4"', 'options' : {'A':[
                {'id' : '131060', 'afr' : '6.0', 'pt' : '3.0'},
                {'id' : '131080', 'afr' : '8.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '131'}
            ], 'C':[
                {'id' : '7603-101'}
            ],}},
    'MCL048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCR048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCB048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCP048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCT048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCK048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCF048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRL048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRR048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRB048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRP048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRT048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRK048' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCL060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCR060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCB060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCP060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCT060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCK060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MCF060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRL060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRR060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRB060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRP060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRT060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MRK060' : {'connection' : '1"', 'options' : {'A':[
                {'id' : '132120', 'afr' : '12.0', 'pt' : '3.0'},
                {'id' : '132150', 'afr' : '15.0', 'pt' : '3.8'},
                {'id' : '132180', 'afr' : '18.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '132'}
            ], 'C':[
                {'id' : '7603-100'}
            ]}},
    'MBL072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBR072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBB072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBP072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
     'MBF072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBC072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBG072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBH072' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBL096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBR096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBB096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBP096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
     'MBF096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBC096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBG096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
    'MBH096' : {'connection' : '1-1/4"', 'options' : {'A':[
                {'id' : '133180', 'afr' : '18.0', 'pt' : '3.0'},
                {'id' : '133200', 'afr' : '20.0', 'pt' : '3.3'},
                {'id' : '133300', 'afr' : '30.0', 'pt' : '5.0'}
            ], 'B':[
                {'id' : '133'}
            ], 'C':[]
        }},
  'HKV084' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200', 'afr' : '20.0', 'pt' : '3.0'},
                {'id' : '134300', 'afr' : '30.0', 'pt' : '4.5'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'HKV096' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200', 'afr' : '20.0', 'pt' : '2.4'},
                {'id' : '134300', 'afr' : '30.0', 'pt' : '3.6'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '4.8'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HBH120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBL120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBR120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBB120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBP120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBF120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBC120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBG120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'MBH120' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134200',  'afr' : '20.0', 'pt' : '2.0'},
                {'id' : '134300',  'afr' : '30.0', 'pt' : '3.0'},
                {'id' : '134400',  'afr' : '40.0', 'pt' : '4.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HKV150' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134300', 'afr' : '30.0', 'pt' : '2.3'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '3.0'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '3.8'}

            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HKV168' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134300', 'afr' : '30.0', 'pt' : '2.3'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '3.0'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '3.8'}

            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},

    'HKV192' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134300', 'afr' : '30.0', 'pt' : '1.8'},
                {'id' : '134400', 'afr' : '40.0', 'pt' : '2.4'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '3.0'},
                {'id' : '134600', 'afr' : '60.0', 'pt' : '3.6'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'HKV240' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134400', 'afr' : '40.0', 'pt' : '2.0'},
                {'id' : '134500', 'afr' : '50.0', 'pt' : '2.5'},
                {'id' : '134600', 'afr' : '60.0', 'pt' : '3.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }},
    'HKV300' : {'connection' : '1-1/2"', 'options' : {'A':[
                {'id' : '134500', 'afr' : '50.0', 'pt' : '2.0'},
                {'id' : '134600', 'afr' : '60.0', 'pt' : '2.0'}
            ], 'B':[
                {'id' : '134'}
            ], 'C':[]
        }}
};

function select (serial) {

    if (! OPTIONS[serial]) {
        return false;
    }

    let serialOptions = OPTIONS[serial];
    let availableOptions = {'2' : {'A' : {}, 'B' : {}, 'C': {}}, '3' : {'A' : {}, 'B' : {}, 'C' : {}}};

    for (let feetOptions of FEET_OPTIONS) {
        let feetType = feetOptions.feet;
        let sectionOptions = availableOptions[feetType];

        for (let sectionId of feetOptions.sections) {
            sectionOptions[sectionId].name = SECTION_NAMES[sectionId];
            sectionOptions[sectionId].options = [];

            let options = sectionOptions[sectionId].options;

            for (let option of serialOptions.options[sectionId]) {
                let row = {};
                if (sectionId == 'C') {
                    row.serial = option.id;
                    row.description = [serialOptions.connection, 'Hose'].join(' ');
                } else {
                    row.serial = feetOptions.id + '-' + option.id;
                    if (sectionId == 'A') {
                        row.description = [serialOptions.connection, option.pt, 'GPM/Ton'].join(' ');
                    } else {
                        // B
                        row.description = [serialOptions.connection, 'Manual'].join(' ');
                    }
                }

                options.push(row);
            }
        }
    }

    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------

    // transform available options
    let transformedOptions = {}

    if (availableOptions['2']['A'].options.length > 0 || availableOptions['3']['A'].options.length > 0) {
        transformedOptions['A'] = {
            'description': (availableOptions['2']['A'].name || availableOptions['3']['A'].name),
            '2-foot': availableOptions['2']['A'].options,
            '3-foot': availableOptions['3']['A'].options
        }
    }

    if (availableOptions['2']['B'].options.length > 0 || availableOptions['3']['B'].options.length > 0) {
        transformedOptions['B'] = {
            'description': (availableOptions['2']['B'].name || availableOptions['3']['B'].name),
            '2-foot': availableOptions['2']['B'].options,
            '3-foot': availableOptions['3']['B'].options
        }
    }

    if (/* availableOptions['2']['C'].options.length > 0 || */ availableOptions['3']['C'].options.length > 0) {
        transformedOptions['C'] = {
            'description': (/* availableOptions['2']['C'].name || */availableOptions['3']['C'].name),
            '2-foot': [], // availableOptions['2']['C'].options,
            '3-foot': availableOptions['3']['C'].options
        }
    }

    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------------------------------------------------------------


    return transformedOptions
}

module.exports = { select }
